module.exports = __webpack_public_path__ + "static/img/checkbox_empty.695563bf.svg";